import { AppViewStore } from '@planning/stores/AppViewStore'
import { shouldShowLoadingIndicator } from '@tom-ui/utils'
import { AxiosError, InternalAxiosRequestConfig } from 'axios'

export const onFulfilled = (appStore: AppViewStore) => {
  return (request: InternalAxiosRequestConfig<any>) => {
    if (shouldShowLoadingIndicator(window.location.pathname, request.url)) {
      appStore.showLoader()
    }

    return request
  }
}

export const onRejected = (appStore: AppViewStore) => {
  return (error: AxiosError) => {
    if (shouldShowLoadingIndicator(window.location.pathname, error.config?.url)) {
      appStore.hideLoader()
    }

    throw error
  }
}
